var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCrowdvotingFoerdersummenVisualisierungInlineRgbDesktop = function SvgCrowdvotingFoerdersummenVisualisierungInlineRgbDesktop(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 480,
    height: 150,
    viewBox: "0 0 480 150",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M194.3,147.65v-8.24l5.92-5.49c9.44-8.81,15.36-16.55,15.36-21.91,0-4.23-3.66-6.62-8.03-6.62-3.38,0-7.12,1.2-11.34,3.94l-.77-8.17c4.51-2.25,9.51-3.52,14.58-3.52,9.79,0,15.43,5.14,15.43,14.37,0,6.83-3.94,14.3-18.53,27.9h20.08v7.75h-32.69Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.86,138.28c4.09,1.76,7.12,2.47,9.93,2.47,6.27,0,10.64-3.1,10.64-8.67s-4.3-8.52-11.27-8.52c-3.03,0-5.92.42-8.81,1.34l.49-26.42h28.25v7.33h-18.95l-.21,10.5c1.69-.28,2.75-.49,4.51-.49,8.81,0,15.85,4.86,15.85,15.92,0,10.07-7.33,16.77-19.16,16.77-3.17,0-7.75-.49-11.48-1.41l.21-8.8Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.2,123.21c0-15.5,5.57-25.57,17.05-25.57s17.19,8.88,17.19,25.57-5.92,25.29-17.19,25.29-17.05-8.03-17.05-25.29ZM296.58,123.21c0-7.4-.21-18.25-7.4-18.25-6.69,0-7.11,10.43-7.11,18.03s.28,18.18,7.18,18.18,7.33-10.64,7.33-17.96Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.19,147.65v-49.17h29.02v7.75h-19.16v12.12h17.54v7.75h-17.54v13.81h19.3v7.75h-29.16Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.88,147.65v-4.93h-.14c-3.1,3.73-7.19,5.78-11.91,5.78-8.1,0-12.33-5.43-12.33-14.23v-22.89h9.44v20.71c0,7.26,2.68,9.09,6.13,9.09,5.71,0,8.31-5.28,8.31-12.26v-17.54h9.44v36.28h-8.95Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.76,147.65v-36.28h8.38v8.24h.14c.56-3.8,4.51-9.09,10-9.09,1.97,0,2.54.21,2.82.28v9.51c-.85-.49-2.54-.78-4.23-.78-3.52,0-7.68,1.9-7.68,13.17v14.93h-9.44Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.57,148.5c-11.69,0-18.95-8.03-18.95-18.74,0-11.62,7.89-19.23,18.95-19.23s19.02,7.54,19.02,19.23c0,10.78-7.33,18.74-19.02,18.74ZM468.73,128.63c0-5.78-3.1-10.78-9.16-10.78s-9.09,5.07-9.09,10.78c0,7.68,2.96,12.54,9.09,12.54s9.16-4.72,9.16-12.54Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.7,1.62H9.53C4.36,1.62,0,5.86,0,11.14v71.29c0,5.17,4.25,9.53,9.53,9.53h38.34c.92,0,1.61.92,1.15,1.84l-20.21,42.71c-1.15,2.41,1.72,4.82,3.9,3.21l62.22-47.41c.11-.11.46-.34.8-.34h70.95c5.17,0,9.53-4.25,9.53-9.53V11.03c.11-5.17-4.13-9.53-9.53-9.53h0v.11Z",
    style: {
      fill: "#e8e171"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.64,64.07c4.02,2.07,7.81,2.87,12.51,2.87s9.87-2.3,9.87-8.61-4.02-7.12-8.95-9.18l-4.02-1.95c-5.05-2.41-9.18-5.86-9.18-12.74,0-10.22,8.95-14.35,16.99-14.35s8.04.46,11.6,1.61l-.46,6.77c-3.44-1.49-7.23-2.07-10.68-2.07s-9.18,1.72-9.18,7.58,3.44,6.08,7.12,7.92l4.25,1.95c6.2,2.87,10.79,5.97,10.79,14.12s-7.92,15.38-17.79,15.38-8.95-.69-13.32-2.07l.34-7.12h.23l-.11-.11Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.8,72.22c-2.41.8-5.05,1.26-7.46,1.26-8.27,0-9.87-5.63-9.87-13.2v-20.66h-7.12v-5.51h7.12v-8.38l7.81-2.53v10.79h8.73v5.51h-8.73v21.7c0,3.44.8,6.08,4.82,6.08s2.87-.34,4.25-.92l.34,5.63.11.34v-.11Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.69,25.95v-7.46h7.81v7.46h-7.81ZM259.69,72.68v-38.69h7.81v38.69h-7.81Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.06,72.68v-29.73c0-3.1,0-5.86-.34-8.95h7.23v6.66c2.76-5.05,6.77-7.46,12.17-7.46s9.99,3.56,11.37,7.92c1.72-4.82,7-7.92,11.82-7.92,8.38,0,12.28,5.63,12.28,13.78v25.72h-7.81v-24.91c0-4.71-1.49-8.61-7-8.61s-8.61,6.31-8.61,12.28v21.24h-7.81v-24.91c0-4.71-1.49-8.61-7-8.61s-8.73,6.31-8.73,12.28v21.24h-7.81.23Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.04,72.68v-29.73c0-3.1,0-5.86-.34-8.95h7.23v6.66c2.76-5.05,6.77-7.46,12.17-7.46s9.99,3.56,11.37,7.92c1.72-4.82,7-7.92,11.82-7.92,8.38,0,12.28,5.63,12.28,13.78v25.72h-7.81v-24.91c0-4.71-1.49-8.61-7-8.61s-8.61,6.31-8.61,12.28v21.24h-7.81v-24.91c0-4.71-1.49-8.61-7-8.61s-8.73,6.31-8.73,12.28v21.24h-7.81.23Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.53,55c0,7.12,4.36,13.09,12.97,13.09s7.23-.8,10.56-2.41l.46,5.63c-3.56,1.49-7.81,2.07-11.94,2.07-13.09,0-19.75-8.27-19.75-20.44s6.66-19.86,17.79-19.86,16.19,8.61,16.19,19.63v2.3h-26.29ZM432.01,50.18c0-5.86-1.72-11.6-8.73-11.6s-9.76,6.08-9.87,11.6h18.6Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.4,72.68v-29.73c0-3.1,0-5.86-.34-8.95h7.23v6.66c2.87-5.05,7.12-7.46,12.74-7.46,9.53,0,12.97,5.97,12.97,15.04v24.45h-7.81v-22.85c0-5.4-1.15-10.68-7.58-10.68s-9.41,6.31-9.41,12.4v21.01h-7.92l.11.11Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.84,126.41v-8.61h42.25v8.61s-42.25,0-42.25,0ZM115.84,144.43v-8.61h42.25v8.61s-42.25,0-42.25,0Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9,75.09V31.01l-9.65,7.85-5.73-7.44,16.68-13.41h10.14v57.09h-11.45Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1,46.71c0-17.99,6.46-29.69,19.79-29.69s19.96,10.31,19.96,29.69-6.87,29.36-19.96,29.36-19.79-9.32-19.79-29.36ZM97.4,46.71c0-8.59-.25-21.19-8.59-21.19-7.77,0-8.26,12.11-8.26,20.94s.33,21.1,8.34,21.1,8.51-12.35,8.51-20.86Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.57,46.71c0-17.99,6.46-29.69,19.79-29.69s19.96,10.31,19.96,29.69-6.87,29.36-19.96,29.36-19.79-9.32-19.79-29.36ZM142.87,46.71c0-8.59-.25-21.19-8.59-21.19-7.77,0-8.26,12.11-8.26,20.94s.33,21.1,8.34,21.1,8.51-12.35,8.51-20.86Z",
    style: {
      fill: "#008c57"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCrowdvotingFoerdersummenVisualisierungInlineRgbDesktop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/crowdvoting-foerdersummen-visualisierung-inline-rgb-desktop.2d99fc061f572c237da95c1d9ba24271.svg";